export const getEnvByDomain = () => {
  const domain = window.location.hostname;
  if (domain.endsWith('playpadel.io')) {
    return 'production';
  }
  if (domain.endsWith('playpadel.dev')) {
    return 'development';
  }
  return 'local';
};
